import React from "react";

import KpiCards from "../components/KpiCards";
import NewsBanner from "../components/NewsBanner";
import NewsCharts from "../components/NewsCharts";
import PostList from "../components/PostList";

export default function NewsFeedPage() {
  return (
    <div className="news-feed-scope !min-h-screen !bg-slate-50/60 !p-3 sm:!p-4 md:!p-5 !text-sm">
      <div className="!max-w-[1760px] !w-full !mx-auto !space-y-4 sm:!space-y-5">
        {/* 1. Header Banner */}
        <NewsBanner />

        {/* 3. Summary Cards (11 cards) */}
        <KpiCards />

        <NewsCharts />

        {/* 4. Main Content Grid */}
        <div className="!grid !grid-cols-1 lg:!grid-cols-12 !gap-5 !items-start">
          {/* Left Column (8 cols): Posts Feed with self-contained CRUD and API */}
          <div className="lg:!col-span-8">
            <PostList />
          </div>

          {/* Right Column (4 cols): Pinned Notices & Warehouse Guidelines */}
          {/* <div className="lg:!col-span-4">
            <RecentDocuments />
          </div> */}
        </div>
      </div>
    </div>
  );
}
